var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav"},[_c('nav',[_c('a',{staticClass:"logo-img",attrs:{"href":"/"}},[_c('img',{attrs:{"src":_vm.pelexLogo,"loading":"lazy","height":"50","alt":"Pelex Logo"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }